const API_BASE_URL = process.env.REACT_APP_U1_VIEWERSVC_API

export const getOrCreateProjectUrl = async (projectRef) => {
    try {
        const cleanRef = String(projectRef).replace('project-', '')
        
        const response = await fetch(
            `${API_BASE_URL}project/${cleanRef}/token`,
            { 
                method: 'POST',
                headers: { 'Content-Type': 'application/json' }
            }
        )
        
        if (response.ok) {
            const data = await response.json()
            return data.shareableLink || `?token=${data.token}`
        }
        
        console.error(`Failed to fetch URL for project ${cleanRef}: ${response.status}`)
        return '#'
    } catch (error) {
        console.error(`Error fetching project URL for ${projectRef}:`, error)
        return '#'
    }
}
